/**
 * @file Agent Container
 * @author malcolmmzma
 */

// import { Button } from '@tencent/spaui';
import { ChatToolBar } from '@tencent/ai-chat-react';
import React from 'react';
import { useHistory } from 'react-router-dom';

// import { ROUTE_PREFIX } from 'configure/base';
// import featureflag from 'utils/featureflag';

// import AiAgentTriggerIcon from './trigger-icon';
import { useSearchParams } from '../../hooks/useSearchParams';

import '@tencent/ai-chat-react/css/index.css';

const AgentContainer = (props: React.HTMLProps<HTMLDivElement>) => {
  const { children, className, style, ...rest } = props;

  const history = useHistory();

  const { searchParamStr } = useSearchParams();


  return (
    <div
      className={`tw-w-full tw-mt-[16px] ${className}`}
      style={{ height: 'calc(100vh - 84px)', minHeight: '800px', ...style }}
      {...rest}
    >
      <div className="ai-agent tw-h-full tw-w-full">
        <ChatToolBar
          className="tw-absolute tw-z-50 tw-top-6 tw-left-6"
          direction="vertical"
          onCreateNew={() => history.push(`/analysis/ai-agent/new?${searchParamStr}`)}
          onShowHistory={() => history.push(`/analysis/ai-agent/history?${searchParamStr}`)}
        />
        {children}
      </div>
    </div>
  );
};

// export const AiAgentTrigger = () => {
//   const history = useHistory();

//   const handleClick = () => {
//     // 检查class=ai-chat-react的div是否已加载
//     const aiChatDiv = document.querySelector('.ai-chat-react-chat-service');
//     if (aiChatDiv) {
//       // 如果已加载，直接跳转到AI Agent页面
//       window.open(`${ROUTE_PREFIX}/analysis/ai-agent`, '_blank');
//       return;
//     }
//     history.push('/analysis/ai-agent');
//   };

//   // 白名单rtx免登录，或命中灰度user_id
//   if (featureflag.isFeatureEnabled('enable_ai_agent')) {
//     return (
//       <Button
//         className="tw-w-full tw-font-semibold flex tw-gap-1 tw-items-center tw-justify-center"
//         style={{ border: '1px solid var(---Purple-03, #D3D4FF)' }}
//         shape="round"
//         onClick={handleClick}
//       >
//         <AiAgentTriggerIcon />
//         <img
//           src="https://qzonestyle.gdtimg.com/gdt_ui_proj/imghub/dist/cm-analysis-agent-name.svg?max_age=31536000"
//           alt="AI Agent"
//           height={14}
//         />
//       </Button>
//     );
//   }

//   return null;
// };

export default AgentContainer;
